/**
 * Brand identity for the current build.
 *
 * Driven by the build-time env var REACT_APP_BRAND. The Flexibook and Anyspot
 * deployments share one codebase; this module is the single source of truth for
 * which brand name + logo set the UI shell should render.
 */

export const BRAND = {
  FLEXIBOOK: "flexibook",
  ANYSPOT: "anyspot",
};

const VALID = new Set(Object.values(BRAND));

/**
 * @returns {"flexibook"|"anyspot"} Current brand. Falls back to "flexibook" if
 * REACT_APP_BRAND is unset or unrecognized.
 */
export const getBrand = () => {
  const raw = (process.env.REACT_APP_BRAND || "").toLowerCase();
  return VALID.has(raw) ? raw : BRAND.FLEXIBOOK;
};

/**
 * @returns {string} Human-facing product name for the current brand.
 */
export const getBrandName = () =>
  getBrand() === BRAND.ANYSPOT ? "Anyspot" : "Flexibook";
